import { useEffect, useState } from 'react';
import ensureTranslations from '%app/js/common/services/translationLoader';
import captureException from '%app/js/common/services/captureException';

function useTranslationsSettled(domains) {
    const [settled, setSettled] = useState(domains.length === 0);

    useEffect(() => {
        if (!settled) {
            const settle = () => setSettled(true);

            ensureTranslations(domains).then(settle, (error) => {
                captureException(error);
                settle();
            });
        }
    }, []);

    return settled;
}

export default useTranslationsSettled;
